import { useDispatch, useSelector } from "react-redux";
import { useLayoutEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { AESDecryption } from "../../utils/Aes";
import { decodeToken, isExpired } from "react-jwt";
import { loginSuccess, logout } from "../../redux/slices/authSlice";
import { Navigate } from "react-router-dom";
import { notifySessionExpired, scheduleSessionExpiryWatch } from "../../utils/sessionExpiry";

const RequireJWT = ({ children }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { token: storeToken, isLoggedIn } = useSelector((state) => state.auth) || {};
    const encryptedToken = localStorage.getItem('token');

    const session = useMemo(() => {
        if (!encryptedToken) {
            return { valid: false, expired: false, payload: null };
        }

        const token = AESDecryption(encryptedToken);
        if (!token) {
            return { valid: false, expired: false, payload: null };
        }

        if (isExpired(token)) {
            return { valid: false, expired: true, payload: null };
        }

        const decodedToken = decodeToken(token);
        return {
            valid: true,
            expired: false,
            payload: {
                token,
                userId: decodedToken.userId,
                firstName: decodedToken.firstName,
                email: decodedToken.email,
                role: decodedToken.role,
            },
        };
    }, [encryptedToken, location.pathname]);

    useLayoutEffect(() => {
        if (!session.valid) {
            if (session.expired) {
                notifySessionExpired();
            }
            if (isLoggedIn) {
                dispatch(logout());
            }
            return;
        }

        scheduleSessionExpiryWatch();

        if (storeToken !== session.payload.token) {
            dispatch(loginSuccess(session.payload));
        }
    }, [dispatch, isLoggedIn, session, storeToken]);

    if (!encryptedToken || !session.valid) {
        return <Navigate to="/login" replace />;
    }

    if (!isLoggedIn) {
        return null;
    }

    return children;
};

export default RequireJWT;
